import styled from 'styled-components';

export const Highlight = styled.span`
  color: var(--clr-secondary);
  font-weight: bold;
`;
